import { Button, Dialog, DialogButtons } from '@st/theme'
import { match } from '@st/pattern'
import type { DocumentContractKind } from './top-bar-types'

export function DeleteContractDialog({
  kind,
  onClose,
  onConfirm
}: {
  kind: DocumentContractKind
  onClose: () => void
  onConfirm: () => void
}) {
  const noun = match(kind)
    .with('engagement_letter', () => 'engagement letter')
    .with('tax_return_delivery', () => 'tax return delivery')
    .exhaustive()

  return (
    <Dialog
      title={`Delete ${noun}?`}
      subtitle={`This will delete the ${noun}.`}
      buttons={
        <DialogButtons>
          <Button variant="default" onClick={onClose}>
            Go back
          </Button>
          <Button variant="primary" onClick={onConfirm}>
            Delete
          </Button>
        </DialogButtons>
      }
    />
  )
}
